import { cronRegexps } from './cron'
import { validateHostname, validateIP4, validateIP6 } from '@/helpers/helpers'

// custom validation rule for password strength
const passStrengthValidator = {
  // args[0] - strength to check
  // args[1] - required strength
  getMessage: (field, args) => 'You must enter stronger password.',
  validate: (value, args) => args[0] >= args[1]
}

const noQuotesValidator = {
  getMessage: () => 'This field contains invalid characters.',
  validate: (value) => !/"+|'+/g.test(value)
}

const cronEmailValidator = {
  getMessage: (field) => `${field} must be a valid email address, empty, or the system account.`,
  validate: (value, args) => {
    // value can contain empty string, account username or valid email address
    // args[0] should contain userAccount value
    const isEmptyOrUser = value === args[0] || value.length === 0
    if (!isEmptyOrUser) {
      // validate email:
      // eslint-disable-next-line no-useless-escape
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return regex.test(value)
    }
    return true
  }
}

const cronMinutesValidator = {
  getMessage: (field) => `You did not format the ${field} value correctly.`,
  validate: (value) => {
    const regex = new RegExp('^' + cronRegexps.minutes.source + '$')
    return regex.test(value)
  }
}

const cronHoursValidator = {
  getMessage: (field) => `You did not format the ${field} value correctly.`,
  validate: (value) => {
    const regex = new RegExp('^' + cronRegexps.hours.source + '$')
    return regex.test(value)
  }
}

const cronDaysValidator = {
  getMessage: (field) => `You did not format the ${field} value correctly.`,
  validate: (value) => {
    const regex = new RegExp('^' + cronRegexps.days.source + '$')
    return regex.test(value)
  }
}

const cronMonthsValidator = {
  getMessage: (field) => `You did not format the ${field} value correctly.`,
  validate: (value) => {
    const regex = new RegExp('^' + cronRegexps.months.source + '$')
    return regex.test(value)
  }
}

const cronWeekdaysValidator = {
  getMessage: (field) => `You did not format the ${field} value correctly.`,
  validate: (value) => {
    const regex = new RegExp('^' + cronRegexps.weekdays.source + '$')
    return regex.test(value)
  }
}

const domainListValidator = (value, args) => {
  // args - array of available domains
  const values = value.split('\n').filter(val => !!val) // get rid of empty strings
  const matchedValues = values.reduce((carry, val) => {
    const matches = args.find((domain) => {
      return domain === val.replace('*.', '')
    })
    if (matches) {
      carry.push(matches)
    }
    return carry
  }, [])
  return matchedValues.length === values.length
}

const ipValidator = {
  getMessage (field, args) {
    return `The ${field} field is incorrect.`
  },
  validate (value, args) {
    if (validateHostname(value)) {
      return true
    } else if (validateIP4(value)) {
      return true
    } else if (validateIP6(value)) {
      return true
    } else {
      return false
    }
  }
}

const domainValidator = {
  getMessage (field) {
    return `Field "${field}" looks like is not a valid domain.`
  },
  validate (value) {
    const NEW_DOMAIN_REGEXP = /^[A-z][^.\s]+(\.[^.\s]{2,}){1,2}$/
    return NEW_DOMAIN_REGEXP.test(value)
  },
}

export {
  passStrengthValidator,
  cronEmailValidator,
  cronMinutesValidator,
  cronHoursValidator,
  cronDaysValidator,
  cronMonthsValidator,
  cronWeekdaysValidator,
  domainListValidator,
  noQuotesValidator,
  ipValidator,
  domainValidator,
}
